import React, { useState, ReactElement } from "react";
import { Modal, ModalHeader, ModalBody } from "../../../Layout";
import FeedbackHistoryContainer from "./FeedbackHistoryContainer";

type Props = {
  code: string;
  triggerButton: ReactElement;
};

type State = {
  isOpen: boolean;
};

export class FeedbackHistoryModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false
    };

    this.onToggle = this.onToggle.bind(this);
  }

  onToggle = () =>
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));

  render() {
    return (
      <div>
        {React.cloneElement(this.props.triggerButton, { onClick: this.onToggle.bind(this) })}
        <Modal isOpen={this.state.isOpen} onToggle={this.onToggle} width="1000px" height="90%">
          <ModalHeader toggle={this.onToggle}>Activity History</ModalHeader>
          <ModalBody>
            <FeedbackHistoryContainer code={this.props.code} />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
